import React from 'react';
// @ts-ignore
import { HistoryLog, Link, Loader } from 'arag-ui-lib';
import DownloadIcon from '../icons/downloadIcon';
import './downloadIcon.scss';
import codes from '../../utils/constants/codes';
import ProgressBar from '../general/progressBar/progressBar';
import { useTranslation } from 'react-i18next';

type Props = {
    createdDate?: any;
    fullName?: string;
    fullFileName?: string;
    clickDownloadButton: (
        id: string | any,
        fullFileName: string | undefined,
        type: string,
    ) => Promise<any> | any;
    documentTypes?: string;
    id: string;
    isLoadingDownload: string | null;
    progressFileDownload: any;
    isDisabled: boolean;
};
const ClaimDocument = (props: Props): JSX.Element => {
    const {
        createdDate,
        fullName,
        fullFileName,
        clickDownloadButton,
        documentTypes,
        id,
        isLoadingDownload,
        progressFileDownload,
        isDisabled,
    } = props;
    const { t } = useTranslation();
    return (
        <>
            <HistoryLog
                createdDate={createdDate}
                createdBy={fullName}
                title={
                    documentTypes === ''
                        ? fullFileName
                        : fullFileName
                              ?.concat('  ')
                              .concat(documentTypes as string)
                }
                log={
                    <>
                        <Link
                            variant={'primary'}
                            onClick={async () => {
                                await clickDownloadButton(
                                    id,
                                    fullFileName,
                                    codes.attachment,
                                );
                            }}
                            label={
                                <div className="download-icon-wrapper">
                                    <DownloadIcon className="download-icon" />{' '}
                                    {t<string>('download')}
                                </div>
                            }
                            disabled={isDisabled}
                        />
                        {isLoadingDownload === id &&
                            !progressFileDownload?.find(
                                (i: { id: string }) => i.id === id,
                            )?.id && (
                                <div
                                    className="row"
                                    style={{ marginTop: '10px' }}
                                >
                                    <ProgressBar
                                        progress={{
                                            id: isLoadingDownload,
                                            progress: 0,
                                        }}
                                        mainStyles={'col-sm-9'}
                                    />
                                </div>
                            )}
                        {progressFileDownload?.find(
                            (i: { id: string | undefined }) => i.id === id,
                        )?.id && (
                            <div className="row" style={{ marginTop: '10px' }}>
                                <ProgressBar
                                    progress={progressFileDownload?.find(
                                        (i: { id: string | undefined }) =>
                                            i.id === id,
                                    )}
                                    mainStyles={'col-sm-9'}
                                />
                            </div>
                        )}
                    </>
                }
            />
        </>
    );
};

export default ClaimDocument;
